import script from "./PrivateEditProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateEditProduct.vue?vue&type=script&setup=true&lang=js"

import "./PrivateEditProduct.vue?vue&type=style&index=0&id=3ef7d6f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef7d6f2"]])

export default __exports__